import { render, staticRenderFns } from "./ExamIntro.vue?vue&type=template&id=5360d920&scoped=true&"
import script from "./ExamIntro.vue?vue&type=script&lang=ts&"
export * from "./ExamIntro.vue?vue&type=script&lang=ts&"
import style0 from "./ExamIntro.vue?vue&type=style&index=0&id=5360d920&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5360d920",
  null
  
)

export default component.exports